module.exports = __webpack_public_path__ + "media/payment-plan.0b181f16.svg";